// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderWrapper-module__wrapper___tO4T0"};